import React from 'react'

import * as S from './styles'

import type { UseFormRegisterReturn } from 'react-hook-form'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string
  errors: boolean
  register: UseFormRegisterReturn
}

const Input: React.FC<InputProps> = ({
  label,
  errors,
  register,
  ...inputProps
}) => {
  return (
    <S.InputContainer errors={errors}>
      <label>{label}</label>
      <input {...inputProps} {...register} />
    </S.InputContainer>
  )
}

export default Input
